import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { EmptyPoolStorageGenProvider } from "presentation/store/EmptyPoolStorageGeneration/EmptyPoolStorageGenProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import EmptyPoolStorageGeneration from "presentation/view/section/EmptyPoolStorageGeneration/EmptyPoolStorageGeneration";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const EmptyPoolStorageGenerationMain = () => {
    return <ANAInfoWrapper permission={Permission.EMPTY_POOL_STORAGE_GEN}>
        <MessageBarWrapper>
            <EmptyPoolStorageGenProvider>
                <GridStyles/>
                <EmptyPoolStorageGeneration/>                
            </EmptyPoolStorageGenProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default EmptyPoolStorageGenerationMain;